import React from 'react';
// import '@style/modules/analysis/keyContractsEdit.scss';
import '../../../../styles/modules/analysis/keyContractsEdit.scss';
import KeyExecutives from '@modules/analysis/summary/keyExecutives';
import { useSelector } from 'react-redux';

function KeyContractsEdit({ toggleMode }) {
  const { projectDetail } = useSelector(({ common, analysis, projects }) => ({
    projectId: common.currentId,
    isShowContacts: analysis.isShowContacts,
    projectDetail:
      Object.keys(projects.projectDetail).length > 0
        ? projects.projectDetail
        : {
            projectInfo: {
              buyerName: common.projectCompanyInfo.buyerName,
              targetName: common.projectCompanyInfo.targetName,
            },
          },
  }));
  return (
    <div className="keyContractsEdit">
      <div className="title-edit">Key Contacts</div>
      <KeyExecutives
        companyNames={projectDetail.projectInfo}
        toggleMode={toggleMode}
      />
    </div>
  );
}

export default KeyContractsEdit;
